import { createSelector } from 'reselect'
import { moduleName } from './constants'

const state = (state) => state[moduleName]

export const stageSelector = createSelector(state, ({ stage }) => stage)
export const resultSelector = createSelector(state, ({ result }) => result)
export const selectedBetSelector = createSelector(
    state,
    ({ selectedBet }) => selectedBet
)
export const battlePlayersSelector = createSelector(
    state,
    ({ battlePlayers }) => battlePlayers
)
